import { gql } from '@apollo/client';

export const GET_ALL_CARDS = gql`
query {
    allReplenishmentCards {
      edges {
        node {
          id,
          name,
          nominalRub,
          priceUsd,
          priceKzt
        }
      }
    }
}`;

export const BUY_CARD = gql`
mutation CreateCardPurchase(
    $customerPhone: String!,
    $customerName: String,
    $customerSurname: String,
    $customerEmail: String,
    $paymentSystem: String = "H"
    $currency: String = "kzt"
    $card: ID!
) {
    createCardPurchase(
        currency: $currency,
        card: $card,
        paymentSystem: $paymentSystem,
        customerData: {
            customerName: $customerName,
            customerEmail: $customerEmail,
            customerSurname: $customerSurname,
            customerPhone: $customerPhone
    }
){
    error
    cardPurchase {
        id
        card {
            id
        }
        pk
        payment{
          status
          id
          amount
          
        }
    }
}}`

export const GET_AUTH = gql`
query($purchaseId: ID!) {
    paymentData(purchaseId:$purchaseId) {
        errors
        data {
          auth {
            access_token
            expires_in
            refresh_token
            scope
            token_type
          }
          invoiceId
          backLink
          failureBackLink
          postLink
          failurePostLink
          language
          description
          terminal
          amount
          currency
        }   
    }
}
`
